import userflow             from 'userflow.js';

import { Injectable } from '@angular/core';

import { CompanyService }        from '../companies/company.service';
import { SessionService }        from '../sessions/session.service';
import { UserflowIdentityModel } from './typings/userflow.identity';
import { UserflowSettingsModel } from './typings/userflow.settings';

@Injectable()
export class UserflowService {
  private readonly _defaultLanguage : string = 'en-us';

  constructor(
    private companyService: CompanyService,
    private sessionService: SessionService
  ) {}

  createIdentity ( settings: UserflowSettingsModel ) : UserflowIdentityModel {
    const session = this.sessionService.base();
    const company = this.companyService.company;

    return {
      company_id                : company.id,
      company_name              : company.company_name || company.name,
      country_code              : company.country_code,
      country_description       : session.country_types?.description,
      demo_user                 : session.demo_user,
      first_login               : company.first_login,
      haynes_pro_lookup_requests: Number(company.haynes_pro_lookup_requests) > 0 || false,
      is_admin                  : session.admin,
      locale_code               : company.language || this._defaultLanguage,
      name                      : company.name || session.username,
      subscription_plan         : session.subscription_plan,
      subscription_status       : session.subscription_status,
      user_id                   : settings.userId
    };
  }

  getSettings () : UserflowSettingsModel | null {
    const session  = this.sessionService.base();

    const envKey                 = session?.product_onboarding?.env_key;
    const identityVerificationId = session?.product_onboarding?.identity_verification_id;
    const userId                 = session?.user_id;

    return {
      defaultLanguage: this._defaultLanguage,
      envKey,
      identityVerificationId,
      userId         : userId };
  }

  /**
   * Initializes the SDK and identifies the current user.
   * Gets params from Company and Session services.
   */
  initialize () : void {
    if (!this.isSetup()) {
      console.error('User is not properly setup');

      return;
    }

    const settings = this.getSettings();
    const identity = this.createIdentity(settings);

    userflow.init(settings.envKey);

    userflow.identify(identity.user_id, identity, {
      signature: settings.identityVerificationId
    });
  }

  isSetup () : boolean {
    const company  = this.companyService.company;
    const session  = this.sessionService.base();

    const envKey                 = session?.product_onboarding?.env_key;
    const identityVerificationId = session?.product_onboarding?.identity_verification_id;
    const userId                 = session?.user_id;

    if (!envKey || !identityVerificationId || !userId || !company?.id) {


      return false;


    }

    return true;
  }
}
